import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';

interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  alignment: 'horizontal' | 'vertical';
  thickness?: number;
  color?: string;
}
const FlexDivider = ({ className, alignment, thickness, color }: DividerProps): JSX.Element => {
  const DEFAULT_THICKNESS = '1px';
  const getThicknessStyle = () => {
    switch (alignment) {
      case 'horizontal':
        return { height: thickness ? `${thickness}px` : DEFAULT_THICKNESS };
      case 'vertical':
        return { width: thickness ? `${thickness}px` : DEFAULT_THICKNESS };
    }
  };

  return (
    <div
      className={clsx(
        `${color ? color : 'bg-[#979393]'}`,
        {
          'w-full': alignment === 'horizontal',
          'self-stretch': alignment === 'vertical',
        },
        className,
      )}
      role="separator"
      aria-hidden="true"
      tabIndex={-1}
      style={getThicknessStyle()}
      data-testid="divider"
    ></div>
  );
};

export default FlexDivider;
